import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';

import HeaderLogo from '../AppLogo/AppLogo';
import HeaderDots from './Components/HeaderDots';
import UserBox from './Components/UserBox';

class Header extends React.Component {
  render() {
    let {
      headerBackgroundColor,
      enableMobileMenuSmall,
      enableHeaderShadow,
    } = this.props;

    return (
      <div
        className={cx('app-header', headerBackgroundColor, {
          'header-shadow': enableHeaderShadow,
        })}
      >
        <HeaderLogo />

        <div
          className={cx('app-header__content', {
            'header-mobile-open': enableMobileMenuSmall,
          })}
        >
          <div className="app-header-right">
            <HeaderDots />
            <UserBox />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
